const MenuItems = [
    {
        name: 'Introduction',
        label: 'Introduction',
        page: true,
        highlight: true,
    },
    {
        name: 'Current Version (5.0)',
        label: 'Current Version (5.0)',
        header: true,
        highlight: true,
        items: [
            {
                name: 'currentver-authentication',
                label: 'Authentication',
                header: true,
                items: [
                    {
                        name: 'currentver-gettoken',
                        label: 'GetToken (POST)',
                        page: true,
                    },
                ],
            },
            {
                name: 'currentver-Lookup-Methods',
                label: 'Lookup Methods',
                header: true,
                items: [
                    {
                        name: 'currentver-taxsoftware',
                        label: 'TaxSoftwareList',
                        page: true,
                    },
                    {
                        name: 'currentver-bindertypes',
                        label: 'BinderTypes',
                        page: true,
                    },
                    {
                        name: 'currentver-servicetypes',
                        label: 'ServiceTypes',
                        page: true,
                    },
                    {
                        name: 'currentver-bindertemplates',
                        label: 'BinderTemplates',
                        page: true,
                    },
                    {
                        name: 'currentver-officelocations',
                        label: 'OfficeLocations',
                        page: true,
                    },
                    {
                        name: 'currentver-binderstatuslist',
                        label: 'BinderStatusList',
                        page: true,
                    },
                    {
                        name: 'currentver-drlcategories',
                        label: 'DRLCategories',
                        page: true,
                    },
                ],
            },
            {
                name: 'currentver-ActionMethods',
                label: 'Action Methods',
                header: true,
                items: [
                    {
                        name: 'currentver-createbinder',
                        label: 'CreateBinder (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-uploadbinderdocuments',
                        label: 'UploadBinderDocuments (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-bindersubmissioncomplete',
                        label: 'SubmitBinder (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-updateprojectid',
                        label: 'UpdateProjectID (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getstatus',
                        label: 'GetStatus (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getdocuments',
                        label: 'GetDocuments (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-downloaddocument',
                        label: 'DownloadDocument (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getdrloutput',
                        label: 'GetDRLOutput (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-changebinderstatus',
                        label: 'ChangeBinderStatus (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getstatesandlocalities',
                        label: 'GetStatesandLocalities (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-downloadbinderpbfx',
                        label: 'DownloadBinderPBFX (POST)',
                        page: true,
                    },
                    // {
                    //     name: 'currentver-downloadbinderpbfxsaml',
                    //     label: 'DownloadBinderPBFXSAML (POST)',
                    //     page: true,
                    // },
                    {
                        name: 'currentver-binderstatuswithstate',
                        label: 'GetBindersStatusWithStates (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getbinderdetails',
                        label: 'GetBinderDetails  (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getbinderpendingitems',
                        label: 'GetBinderPendingItems (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getbinderauditlog',
                        label: 'GetBinderAuditLog (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-updateownermember',
                        label: 'UpdateOwnerMember (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-printbinder',
                        label: 'PrintBinder (POST)',
                        page: true,  
                    },
                    {
                        name: 'currentver-getdrlpdfdetails',
                        label: 'GetDRLPDFDetails (POST)',
                        page: true,
                    },
                ],
            },
            {
                name: 'TaxCaddy',
                label: 'TaxCaddy',
                header: true,
                items: [
                    {
                        name: 'currentver-createclient',
                        label: 'CreateClient (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getclientdetails',
                        label: 'GetClientDetails (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-createdrl',
                        label: 'CreateDRL (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-senddrl',
                        label: 'SendDRL (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-clientsubscribe',
                        label: 'ClientSubscribe (PUT)',
                        page: true,
                    },
                    {
                        name: 'currentver-clientunsubscribe',
                        label: 'ClientUnsubscribe (PUT)',
                        page: true,
                    },
                    {
                        name: 'currentver-taxcaddydownloaddocument',
                        label: 'DownloadDocument (POST)',
                        page: true,
                    },
                 
                    {
                        name: 'currentver-getdrlstatus',
                        label: 'GetDRLStatus (POST)',
                        page: true,
                   },
                    // {
                    //     name: 'currentver-drl',
                    //     label: 'DRL (POST)',
                    //     page: true,
                    // }
                  {
                        name: 'currentver-taxcaddydisconnectdevices',
                        label: 'DisconnectDevices (POST)',
                        page: true,
                    },                       
                ],
            },
            {
                name: 'currentver-Lists',
                label: 'Lists',
                header: true,
                items: [
                    {
                        name: 'currentver-unclearednotes',
                        label: 'GetUnclearedNotes (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-unreviewedtrstamps',
                        label: 'GetUnreviewedTRStamps(POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-getunreviewedstickynotes',
                        label: 'GetUnreviewedStickyNotes (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-unreviewedworkpapersbyl1',
                        label: 'GetUnreviewedWorkpapersByL1 (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-unreviewedworkpapersbyl2',
                        label: 'GetUnreviewedWorkpapersByL2 (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-unreviewedworkpapersbyl3',
                        label: 'GetUnreviewedWorkpapersByL3 (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-unreviewedworkpapersByl4',
                        label: 'GetUnreviewedWorkpapersByL4 (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-requesteddocspendingreview',
                        label: 'GetDocumentPendingReviewCount (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-requesteddocspendingsignature',
                        label: 'GetDocumentPendingSignatureCount (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-requesteddocspendingupload',
                        label: 'GetDocumentPendingUploadCount (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-mireports',
                        label: 'GetReport (POST)',
                        page: true,
                    },
                    // ,
                    // {
                    //     name: 'currentver-PushEngagementStatus',
                    //     label: 'PushEngagementStatus (GET)',
                    //     page: true,
                    // },
                    // {
                    //     name: 'currentver-PushDocumentType',
                    //     label: 'PushDocumentType (GET)',
                    //     page: true,
                    // },
                ],
            },
            {
                name: 'Billing',
                label: 'Billing',
                header: true,
                items: [
                    {
                        name: 'currentver-accountusagehistory',
                        label: 'AccountUsageHistory (POST)',
                        page: true,
                    },
                ],
            },
            {
                name: 'Notifications(WebHooks)',
                label: 'Notifications (WebHooks)',
                header: true,
                items: [
                    {
                        name: 'currentver-pushengagementstatus',
                        label: 'PushEngagementStatus (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-pushdocumenttype',
                        label: 'PushDocumentType (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-documentsuploaded',
                        label: 'DocumentsUploaded (POST)',
                        page: true,
                    },
                    {
                        name: 'currentver-drl',
                        label: 'DRL (POST)',
                        page: true,
                    },
                ],
            },
        ],
    },

    {
        name: 'Old Version (4.0)',
        label: 'Old Version (4.0)',
        header: true,
        highlight: true,
        items: [
            {
                name: 'version4-Authentication',
                label: 'Authentication',
                header: true,
                items: [
                    {
                        name: 'version4-gettoken',
                        label: 'GetToken (POST)',
                        page: true,
                    },
                ],
            },
            {
                name: 'version4-Lookup-Methods',
                label: 'Lookup Methods',
                header: true,
                items: [
                    {
                        name: 'version4-taxsoftware',
                        label: 'TaxSoftware',
                        page: true,
                    },
                    {
                        name: 'version4-bindertypes',
                        label: 'BinderTypes',
                        page: true,
                    },
                    {
                        name: 'version4-servicetypes',
                        label: 'ServiceTypes',
                        page: true,
                    },
                    {
                        name: 'version4-bindertemplates',
                        label: 'BinderTemplates',
                        page: true,
                    },
                    {
                        name: 'version4-officelocations',
                        label: 'OfficeLocations',
                        page: true,
                    },
                    {
                        name: 'version4-binderstatuslist',
                        label: 'BinderStatusList',
                        page: true,
                    },
                    {
                        name: 'version4-drlcategories',
                        label: 'DRLCategories',
                        page: true,
                    },
                ],
            },

            {
                name: 'version4-ActionMethods',
                label: 'Action Methods',
                header: true,
                items: [
                    {
                        name: 'version4-createbinder',
                        label: 'CreateBinder (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-uploadbinderdocuments',
                        label: 'UploadBinderDocuments (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-bindersubmissioncomplete',
                        label: 'BinderSubmissionComplete (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-updateprojectid',
                        label: 'UpdateProjectID (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getstatus',
                        label: 'GetStatus (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getdocuments',
                        label: 'GetDocuments (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-downloaddocument',
                        label: 'DownloadDocument (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getdrloutput',
                        label: 'GetDRLOutput (POST)',
                        page: true,
                    },

                    {
                        name: 'version4-changebinderstatus',
                        label: 'ChangeBinderStatus (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getstatesandlocalities',
                        label: 'GetStatesandLocalities (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-downloadbinderpbfx',
                        label: 'DownloadBinderPBFX (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-binderstatuswithstate',
                        label: 'GetBindersStatusWithStates (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getbinderdetails',
                        label: 'BinderDetails (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getbinderpendingitems',
                        label: 'GetBinderInfo (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getbinderauditlog',
                        label: 'GetBinderAuditLog (POST)',
                        page: true,
                    },
                ],
            },
            {
                name: 'version4-Lists',
                label: 'Lists',
                header: true,
                items: [
                    {
                        name: 'version4-unclearednotes',
                        label: 'UnclearedNotes (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-unreviewedtrstamps',
                        label: 'UnreviewedTRStamps (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-getunreviewedstickynotes',
                        label: 'GetUnreviewedStickyNotes (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-unreviewedworkpapersbyl1',
                        label: 'UnreviewedWorkpapersByL1 (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-unreviewedworkpapersbyl2',
                        label: 'UnreviewedWorkpapersByL2 (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-unreviewedworkpapersbyl3',
                        label: 'UnreviewedWorkpapersByL3 (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-unreviewedworkpapersByl4',
                        label: 'UnreviewedWorkpapersByL4 (POST)',
                        page: true,
                    },
                    {
                        name: 'version4-requesteddocspendingreview',
                        label: 'DocumentPendingReviewCount(POST)',
                        page: true,
                    },
                    {
                        name: 'version4-requesteddocspendingsignature',
                        label: 'DocumentPendingSignatureCount(POST)',
                        page: true,
                    },
                    {
                        name: 'version4-requesteddocspendingupload',
                        label: 'DocumentPendingUploadCount (POST',
                        page: true,
                    },
                ],
            },
        ],
    },
];

export default MenuItems;
